import {Buffer} from 'buffer'

const ReadFrameInfo = (obj: any, offset: number, length: number) => {
  var dv = new DataView(obj, offset, length)
  var FrameInfo: any = {}
  FrameInfo.StructId = {}
  FrameInfo.StreamInfo = {}
  FrameInfo.AVInfo = {}
  FrameInfo.Gps = {}
  FrameInfo.Gps.GpsUtc = {}
  FrameInfo.GSensor = {}

  FrameInfo.StructId.Id = dv.getUint32(0, true)

  // console.log('Asdp[asp[dka[sd', FrameInfo.StructId.Id)
  if (FrameInfo.StructId.Id != 0xe1ef00aa) {
    console.log('FrameInfo is not valid!! %x', FrameInfo.StructId.Id)
    return -1
  }

  FrameInfo.StructId.Ver = dv.getUint8(4)
  FrameInfo.StructId.Res1 = dv.getUint8(5)
  FrameInfo.StructId.Res2 = dv.getInt16(6, true)

  FrameInfo.StreamInfo.MediaType = dv.getUint8(8)
  FrameInfo.StreamInfo.FrameOffset = dv.getUint32(9, true)
  FrameInfo.StreamInfo.FrameSize = dv.getUint32(13, true)
  FrameInfo.StreamInfo.TimeSec = dv.getUint32(17, true)
  FrameInfo.StreamInfo.OffsetMin = dv.getInt16(21, true)
  FrameInfo.StreamInfo.IsDST = dv.getUint8(23)
  FrameInfo.StreamInfo.Reserved = dv.getUint8(24)
  FrameInfo.StreamInfo.TimeMsec = dv.getUint16(25, true)
  FrameInfo.StreamInfo.SeqActive = dv.getUint32(27, true)
  FrameInfo.StreamInfo.SeqSave = dv.getUint32(31, true)

  FrameInfo.AVInfo.CodecType = dv.getUint8(35)
  FrameInfo.AVInfo.Channel = dv.getUint8(36)

  var avinf = dv.getUint8(37)
  FrameInfo.AVInfo.VideoFrameType = avinf & 0xf
  FrameInfo.AVInfo.Encrypt = avinf >> 7

  FrameInfo.AVInfo.VideoWidth = dv.getUint16(38, true)
  FrameInfo.AVInfo.VideoHeight = dv.getUint16(40, true)
  FrameInfo.AVInfo.RecordType = dv.getUint8(42)
  FrameInfo.AVInfo.VideoRatio = dv.getUint8(43)
  FrameInfo.AVInfo.RecordAudio = dv.getUint8(44)

  FrameInfo.Gps.Valid = dv.getInt8(45)
  FrameInfo.Gps.Lat = dv.getFloat64(46, true)
  FrameInfo.Gps.Lon = dv.getFloat64(54, true)
  FrameInfo.Gps.Spd = dv.getUint16(62, true)
  FrameInfo.Gps.Alt = dv.getUint16(64, true)
  FrameInfo.Gps.Hd = dv.getUint16(66, true)
  FrameInfo.Gps.GpsUtc.Y = dv.getUint16(68, true)
  FrameInfo.Gps.GpsUtc.Mo = dv.getUint16(70, true)
  FrameInfo.Gps.GpsUtc.Dw = dv.getUint16(72, true)
  FrameInfo.Gps.GpsUtc.D = dv.getUint16(74, true)
  FrameInfo.Gps.GpsUtc.H = dv.getUint16(76, true)
  FrameInfo.Gps.GpsUtc.M = dv.getUint16(78, true)
  FrameInfo.Gps.GpsUtc.S = dv.getUint16(80, true)
  FrameInfo.Gps.GpsUtc.Ms = dv.getUint16(82, true)

  FrameInfo.GSensor.X = dv.getUint16(84, true)
  FrameInfo.GSensor.Y = dv.getUint16(86, true)
  FrameInfo.GSensor.Z = dv.getUint16(88, true)

  FrameInfo.EventType = dv.getUint16(90, true)
  FrameInfo.MotionChannel = dv.getUint16(90, true)
  FrameInfo.CarSignal = dv.getUint8(94)
  FrameInfo.CarPulse = dv.getUint16(95, true)
  FrameInfo.AlarmIn = dv.getUint16(97, true)
  FrameInfo.AlarmOut = dv.getUint16(99, true)

  FrameInfo.TimeGap = FrameInfo.StreamInfo.TimeSec * 1000 + FrameInfo.StreamInfo.TimeMsec

  FrameInfo.AdasEvt = dv.getUint8(116)
  if (FrameInfo.AdasEvt !== 0) {
    console.log('Adas', FrameInfo.AdasEvt)
  }

  return FrameInfo
}

// export const decodeStream = (ImageObjList: any) => {
//   for (let i = 0; i < ImageObjList.length; i++) {
//     const Data = atob(ImageObjList[i])

//     var buf = new ArrayBuffer(Data.length)
//     var bufV = new Uint8Array(buf)

//     for (var j = 0; j < Data.length; j++) {
//       bufV[j] = Data.charCodeAt(j)
//     }

//     const FrameInfo = ReadFrameInfo(buf, 0, 117)

//     if (FrameInfo && FrameInfo?.AVInfo?.CodecType == 0) {
//       continue
//     }

//     if (FrameInfo.AVInfo.Channel < 2) {
//       let Frame = new Uint8Array(buf.slice(117, 117 + FrameInfo.StreamInfo.FrameSize))

//       return uint8ArrayToBase64(Frame.buffer)
//     }
//   }
// }

// export const decodeSnapshot = (ImageObj: any) => {
//   const Data = atob(ImageObj)

//   var buf = new ArrayBuffer(Data.length)
//   var bufV = new Uint8Array(buf)

//   for (var j = 0; j < Data.length; j++) {
//     bufV[j] = Data.charCodeAt(j)
//   }

//   let dv = new DataView(buf, 0, buf.byteLength)
//   let size = 117
//   let cur = 0
//   let FrameInfo

//   var picturecount = dv.getInt16(0, true)

//   cur += 2

//   for (var i = 0; i < picturecount; i++) {
//     cur += 4
//     FrameInfo = ReadFrameInfo(buf, cur, size)

//     if (FrameInfo && FrameInfo?.AVInfo?.CodecType == 0) {
//       continue
//     }

//     cur += size
//     if (FrameInfo.AVInfo.Channel < 2) {
//       let Frame = new Uint8Array(buf.slice(cur, cur + FrameInfo.StreamInfo.FrameSize))

//       return uint8ArrayToBase64(Frame.buffer)
//     }
//     cur += FrameInfo.StreamInfo.FrameSize
//   }
// }

export const decodeStream = (ImageObjList: any) => {
  const framesArray = []

  for (let i = 0; i < ImageObjList.length; i++) {
    const Data = atob(ImageObjList[i])

    const buf = new ArrayBuffer(Data.length)
    const bufV = new Uint8Array(buf)

    for (let j = 0; j < Data.length; j++) {
      bufV[j] = Data.charCodeAt(j)
    }

    const FrameInfo = ReadFrameInfo(buf, 0, 117)

    if (FrameInfo && FrameInfo?.AVInfo?.CodecType === 0) {
      continue
    }

    if (FrameInfo.AVInfo.Channel < 2) {
      const Frame = new Uint8Array(buf.slice(117, 117 + FrameInfo.StreamInfo.FrameSize))

      framesArray.push(uint8ArrayToBase64(Frame.buffer))
    }
  }

  return framesArray
}

export const decodeSnapshot = (ImageObj: any) => {
  const Data = atob(ImageObj)

  var buf = new ArrayBuffer(Data.length)
  var bufV = new Uint8Array(buf)

  for (var j = 0; j < Data.length; j++) {
    bufV[j] = Data.charCodeAt(j)
  }

  let dv = new DataView(buf, 0, buf.byteLength)
  let size = 117
  let cur = 0
  let FrameInfo

  var picturecount = dv.getInt16(0, true)

  cur += 2

  const framesArray = []

  for (var i = 0; i < picturecount; i++) {
    cur += 4
    FrameInfo = ReadFrameInfo(buf, cur, size)

    if (FrameInfo && FrameInfo?.AVInfo?.CodecType == 0) {
      continue
    }

    cur += size
    if (FrameInfo.AVInfo.Channel < 2) {
      let Frame = new Uint8Array(buf.slice(cur, cur + FrameInfo.StreamInfo.FrameSize))

      framesArray.push(uint8ArrayToBase64(Frame.buffer))
    }
    cur += FrameInfo.StreamInfo.FrameSize
  }

  return framesArray
}

const uint8ArrayToBase64 = (uint8Array: any) => {
  // Step 1: Convert Uint8Array to Buffer
  const buffer = Buffer.from(uint8Array)

  // Step 2: Convert Buffer to Base64 string
  const base64String = buffer.toString('base64')

  return base64String
}
